module.exports = __webpack_public_path__ + "img/PUDO.ebdd0ca8.png";